import GetRevenueAnalysisDummyData from "../../../dummy/GetRevenueAnalysisDummyData.json";
import GetRevenueShopListDummyData from "../../../dummy/GetRevenueShopListDummyData.json";
import GetRevenueDayDummyData from "../../../dummy/GetRevenueDayDummyData.json";
import GetRevenueTotalDummyData from "../../../dummy/GetRevenueTotalDummyData.json";
import GetRevenueOrderListDummyData from "../../../dummy/GetRevenueOrderListDummyData.json";
import SaveRevenueVoidDummyData from "../../../dummy/SaveRevenueVoidDummyData.json";
import GetRevenueVoidDummyData from "../../../dummy/GetRevenueVoidDummyData.json";
import UploadIndiaTransactionDummyData from "../../../dummy/UploadIndiaTransactionDummyData.json";
import GetIndiaReportDummyData from "../../../dummy/GetIndiaReportDummyData.json";
import GetUsageDayDummyData from "../../../dummy/GetUsageDayDummyData.json";
import GetUsageWeekDummyData from "../../../dummy/GetUsageWeekDummyData.json";
import GetUsageHourWeekDummyData from "../../../dummy/GetUsageHourWeekDummyData.json";
import GetUsageShopListDummyData from "../../../dummy/GetUsageShopListDummyData.json";
import GetUsageDeviceDummyData from "../../../dummy/GetUsageDeviceDummyData.json";
import SuccessResponse from "../dto/common/SuccessResponse";
import RevenueAnalysisDto from "../dto/revenue/RevenueAnalysisDto";
import RevenueShopDto from "../dto/revenue/RevenueShopDto";
import RevenueDayDto from "../dto/revenue/RevenueDayDto";
import RevenueTotalDto from "../dto/revenue/RevenueTotalDto";
import RevenueOrderListDto from "../dto/revenue/RevenueOrderListDto";
import RevenueVoidRespDto from "../dto/revenue/RevenueVoidRespDto";
import RevenueVoidSumDto from "../dto/revenue/RevenueVoidSumDto";
import IndiaReportDto from "../dto/revenue/IndiaReportDto";
import UsageDayDto from "../dto/revenue/UsageDayDto";
import UsageWeekDto from "../dto/revenue/UsageWeekDto";
import UsageHourWeekDto from "../dto/revenue/UsageHourWeekDto";
import UsageShopDto from "../dto/revenue/UsageShopDto";
import UsageDeviceDto from "../dto/revenue/UsageDeviceDto";

class FakeRevenueApi {
    getRevenueAnalysis = async (): Promise<SuccessResponse<RevenueAnalysisDto[]>> => {
        return GetRevenueAnalysisDummyData as SuccessResponse<RevenueAnalysisDto[]>;
    };

    getRevenueShop = async (): Promise<SuccessResponse<RevenueShopDto[]>> => {
        return GetRevenueShopListDummyData as SuccessResponse<RevenueShopDto[]>;
    };

    getRevenueDay = async (): Promise<SuccessResponse<RevenueDayDto[]>> => {
        return GetRevenueDayDummyData as SuccessResponse<RevenueDayDto[]>;
    };

    getRevenueTotal = async (): Promise<SuccessResponse<RevenueTotalDto[]>> => {
        return GetRevenueTotalDummyData as SuccessResponse<RevenueTotalDto[]>;
    };

    getRevenueOrderList = async (): Promise<SuccessResponse<RevenueOrderListDto>> => {
        return GetRevenueOrderListDummyData as SuccessResponse<RevenueOrderListDto>;
    };

    saveRevenueVoid = async (): Promise<SuccessResponse<RevenueVoidRespDto>> => {
        return SaveRevenueVoidDummyData as SuccessResponse<RevenueVoidRespDto>;
    };

    getRevenueVoid = async (): Promise<SuccessResponse<RevenueVoidSumDto>> => {
        return GetRevenueVoidDummyData as SuccessResponse<RevenueVoidSumDto>;
    };

    uploadIndiaTransaction = async (): Promise<SuccessResponse<object>> => {
        return UploadIndiaTransactionDummyData;
    };

    getIndiaReport = async (): Promise<SuccessResponse<IndiaReportDto[]>> => {
        return GetIndiaReportDummyData as unknown as SuccessResponse<IndiaReportDto[]>;
    };

    getUsageDay = async (): Promise<SuccessResponse<UsageDayDto[]>> => {
        return GetUsageDayDummyData as SuccessResponse<UsageDayDto[]>;
    };

    getUsageWeek = async (): Promise<SuccessResponse<UsageWeekDto[]>> => {
        return GetUsageWeekDummyData as SuccessResponse<UsageWeekDto[]>;
    };

    getUsageHourWeek = async (): Promise<SuccessResponse<UsageHourWeekDto[]>> => {
        return GetUsageHourWeekDummyData as SuccessResponse<UsageHourWeekDto[]>;
    };

    getUsageShop = async (): Promise<SuccessResponse<UsageShopDto[]>> => {
        return GetUsageShopListDummyData as SuccessResponse<UsageShopDto[]>;
    };

    getUsageDevice = async (): Promise<SuccessResponse<UsageDeviceDto>> => {
        return GetUsageDeviceDummyData as SuccessResponse<UsageDeviceDto>;
    };

    generateRevenueCumulative = async (): Promise<SuccessResponse<{ message: string }>> => {
        return { resultCode: "0000", result: { message: "success" } };
    };
}

export default FakeRevenueApi;
